import styled from "styled-components";

const IconButtonWrapper = styled.div`
    position: relative;
    border: 1px solid ${props => props.theme.lime};
    border-radius: 0.5rem;
    background: ${props => props.theme.yellow};
    text-align: center;
    margin-right: 3rem;
    margin-bottom: 1rem;
    padding: 1.4rem 0;
    width: 100%;
    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        width: 27rem;
    }
`;

const IconButtonInner = styled.div`
    display: flex;
    justify-content: center;
`;

const IconButtonIcon = styled.span`
    margin-right: 0;
`;

const IconButtonLabel = styled.p`
    text-decoration: none;
    color: ${props => props.theme.darkGrey};
    font-weight: bold;
    font-family: ${props => props.theme.fontBold};
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    margin-bottom: 0;
    margin-left: -0.5rem;
    font-size: 1.8rem;
`;

const IconButtonLink = styled.a``;

export { IconButtonWrapper, IconButtonInner, IconButtonIcon, IconButtonLabel, IconButtonLink };
